import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BeachyAttributes } from 'src/objects/beachy-object';
import { Owner } from 'src/objects/owner';
import { ServiceArea } from 'src/objects/service-area';
import { BaseService } from './base.service';

export interface Storefront extends BeachyAttributes{
  slug: string;
  name: string;
  description: string;
  tipping: boolean;
  owners: [Owner];

  same_day_time_offset: number;
  background_image_url: string;

  destination_search: boolean;
  delivery: boolean;

}

@Injectable({
  providedIn: 'root'
})
export class StorefrontService extends BaseService {
  createInstance = (attributes: Storefront) => attributes;

  getStorefrontAndServiceAreas(): Observable<{ storefront: Storefront; serviceAreas: ServiceArea[] }> {
    return combineLatest([
      this.get(),
      this.getServiceAreas(),
    ])
    .pipe(
      map(([storefront, serviceAreas]) => ({
        storefront,
        serviceAreas,
      })),
    );
  }

  getAll(): Observable<Storefront[]> {
    const url = `${ this.baseUrl }/public/storefronts/`;
    const mapTo = (attributes: Storefront) => attributes as Storefront;

    return this.getPagedRequest<Storefront, Storefront>({ url, params: {}, mapTo });
  }

  get(): Observable<Storefront> {
    const url = `${ this.baseUrl }/public/storefronts/${ this.hostname }`;

    return this.http.get<Storefront>(url);
  }

  getServiceAreas(): Observable<ServiceArea[]> {
    const url = `${ this.baseUrl }/public/service_areas/`;
    const params = {
      ['storefront_slug']: this.hostname,
    };

    const mapTo = (attributes: ServiceArea) => attributes as ServiceArea;
    return this.getPagedRequest<ServiceArea, ServiceArea>({ url, params, mapTo });
  }
}
